module.exports = __webpack_public_path__ + "static/media/Instagram_circle.050116ac.png";